/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemNode_Node = {
    readonly __typename: string;
    readonly id: string;
    readonly name?: string | null | undefined;
    readonly groupName?: string | null | undefined;
    readonly nameJson?: unknown | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
    readonly " $refType": "ListItemNode_Node";
};
export type ListItemNode_Node$data = ListItemNode_Node;
export type ListItemNode_Node$key = {
    readonly " $data"?: ListItemNode_Node$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemNode_Node">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "condition": "includeAvatar",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_Node"
    }
  ]
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAvatar"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemNode_Node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Provider",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Patient",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "groupName",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "Group",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nameJson",
          "args": null,
          "kind": "ScalarField",
          "name": "new",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "Audit",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();
(node as any).hash = '0fdbec668ae3b61888024ed83ff49d67';
export default node;
